import { StringField } from '@components/Fields/StringField';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { useField } from '@hooks/useField';
import { IconButton, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';

export type PagamentoFilterProps = {
    onSearch: (term?: string) => void
    isLoading: boolean
}

export function PagamentoFilter ({ onSearch, isLoading }: PagamentoFilterProps) {
    const searchField = useField();
    const cls = useStyles();

    const handleSearchKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onSearch(searchField.getInputValue());
        }
    }, [onSearch, searchField]);

    const handleSearch = React.useCallback(() => {
        onSearch(searchField.getInputValue());
    }, [onSearch, searchField]);

    return (
        <FilterBar>
            <GridItem>
                <Typography className={cls.title}>Faturas em Aberto</Typography>
            </GridItem>

            <GridItem floatRight>
                <HorizontalGrid verticalAlign="center">
                    <GridItem>
                        <StringField
                            field={searchField}
                            placeholder="Pesquisar"
                            fullWidth={false}
                            onKeyDown={handleSearchKeyDown}
                        />
                    </GridItem>

                    <GridItem>
                        <IconButton onClick={handleSearch} disabled={isLoading}>
                            <SearchIcon />
                        </IconButton>
                    </GridItem>
                </HorizontalGrid>
            </GridItem>
        </FilterBar>
    )
}

const useStyles = makeStyles(theme => ({
    title: {
        fontWeight: 'bold'
    }
}));